import { Observable } from 'rxjs';

import { UnitResult } from '../../../../error';

export interface ApplyToJobShiftsRequest {
    jobID: number;
    shiftIDs: number[];
    guardRate: number;
    notes?: string;
    repeatShifts: boolean;
}

export abstract class ApplyToJobShiftsService {
    abstract applyToJobShifts(request: ApplyToJobShiftsRequest): Observable<UnitResult<void>>;
}
